export const GET_OFFCHAIN_CHAN_LIST = 'GET_OFFCHAIN_CHAN_LIST' //链下扩容通道
export const GET_OFFCHAIN_TX_LIST = 'GET_OFFCHAIN_TX_LIST' //链下扩容通道交易列表
export const GET_OFFCHAIN_CHAN_TX_LIST = 'GET_OFFCHAIN_CHAN_TX_LIST' //链下扩容通道交易列表
